export interface IUiTabsOption {
  value: string | number;
  label: string;
}

export enum UI_TABS_VARIANT {
  PILL = 'pill',
  ROUNDED = 'rounded',
}

export interface IUiTabsProps {
  options: IUiTabsOption[];
  label?: string;
  disabled?: boolean;
  variant?: UI_TABS_VARIANT;
}
